module.exports = __webpack_public_path__ + "img/95.f55fadd7.jpg";